import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useLang } from '../../util/lang';

const useStyles = makeStyles({
    dialogCloseButton: {
        backgroundColor: '#532a74 !important',
        color: '#fff !important',
        '&:hover': {
            backgroundColor: '#532a74 !important',
            color: '#fff !important',
        },
    },
});
// 提示弹窗组件，展示内容并提供关闭按钮。
export default function AlertDialog(props) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const get = useLang('');
    const classes = useStyles();
    return (
        <div>
            <Dialog
                open={props.dialogOpen}
                onClose={props.handleDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{ style: props.styleDialog ? props.styleDialog : {} }}
            >
                <DialogTitle id="alert-dialog-title" className={classes.dialogTitle}>
                    {props.title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText
                        id="alert-dialog-description"
                        style={{ whiteSpace: 'pre-line' }}
                        dangerouslySetInnerHTML={{ __html: props.content }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button className={classes.dialogCloseButton} onClick={props.handleDialogClose}>
                        {get(':const.close')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
